import React, { useState } from 'react';

const WhitelistManager: React.FC<{
  title: string;
  items: string[];
  placeholder: string;
  validator: (item: string) => boolean;
  validationMessage: string;
  onItemsChange: (items: string[]) => void;
}> = ({ title, items = [], placeholder, validator, validationMessage, onItemsChange }) => {
  const [newItem, setNewItem] = useState('');
  const [error, setError] = useState('');

  const addItem = () => {
    if (!newItem.trim()) return;
    
    if (!validator(newItem.trim())) {
      setError(validationMessage);
      return;
    }
    
    if (items.includes(newItem.trim())) {
      setError('This item is already in the list');
      return;
    }
    
    onItemsChange([...items, newItem.trim()]);
    setNewItem('');
    setError('');
  };

  const removeItem = (index: number) => {
    const updatedItems = items.filter((_, i) => i !== index);
    onItemsChange(updatedItems);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addItem();
    }
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">{title}</label>
      
      {/* Add new item */}
      <div className="flex space-x-2 mb-3">
        <input
          type="text"
          value={newItem}
          onChange={(e) => {
            setNewItem(e.target.value);
            setError('');
          }}
          onKeyPress={handleKeyPress}
          className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-netlify-teal focus:border-transparent text-sm"
          placeholder={placeholder}
        />
        <button
          type="button"
          onClick={addItem}
          className="px-4 py-2 bg-netlify-teal text-white rounded-lg hover:bg-netlify-600 transition-colors text-sm font-medium"
        >
          Add
        </button>
      </div>
      
      {error && (
        <p className="text-red-600 text-sm mb-3">{error}</p>
      )}
      
      {/* Display items */}
      {items.length > 0 ? (
        <div className="space-y-2 max-h-40 overflow-y-auto">
          {items.map((item, index) => (
            <div key={index} className="flex items-center justify-between bg-gray-50 px-3 py-2 rounded-lg">
              <span className="text-sm font-mono">{item}</span>
              <button
                type="button"
                onClick={() => removeItem(index)}
                className="text-red-600 hover:text-red-800 text-sm font-medium"
              >
                Remove
              </button>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-500 text-sm italic">No items added. Leave empty to allow all users.</p>
      )}
    </div>
  );
};

export default WhitelistManager;